import {inlineError} from '@s-ui/decorators'

import {SearchRepository} from './SearchRepository.js'

/**
 * @class
 * @implements SearchRepository
 */
export class LocalStorageSearchRepository extends SearchRepository {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.adsRawListToAdsListVOMapper
   * @param {Object} deps.config
   * @param {Storage} deps.localStorage
   * @param {ValueObject} deps.navigationDataValueObject
   * @param {Object} deps.navigationDataVOToNavigationLinksVOMapper
   */
  constructor({
    adsRawListToAdsListVOMapper,
    config,
    localStorage,
    navigationDataValueObject,
    navigationDataVOToNavigationLinksVOMapper
  }) {
    super()

    this._adsRawListToAdsListVOMapper = adsRawListToAdsListVOMapper
    this._config = config
    this._localStorage = localStorage
    this._navigationDataValueObject = navigationDataValueObject
    this._navigationDataVOToNavigationLinksVOMapper = navigationDataVOToNavigationLinksVOMapper

    this._NAVIGATION_DATA_KEYS = this._config.get('NAVIGATION_DATA_KEYS')
    this._NAVIGATION_TYPES = this._config.get('NAVIGATION_TYPES')

    this._getUniqueAds = (adsList = []) =>
      adsList.filter((ad, pos, arr) => {
        return arr.map(mapAd => mapAd.getId()).indexOf(ad.getId()) === pos
      })
  }

  /**
   * Support for MONOLITO Ad Detail
   */
  _setLegacyNavigationData({items, nextPageUrl, prevPageUrl, searchUrl, totalResults, currentPage}) {
    const itemsIds = items.map(({id}) => Number(id))
    const startRegister = itemsIds.length * (currentPage - 1) + 1

    const legacyNavigationData = {
      BackURL: searchUrl,
      IDs: itemsIds,
      NextURL: nextPageUrl,
      PrevURL: prevPageUrl,
      StartRegister: startRegister,
      Total: totalResults
    }

    this._localStorage.setItem('pag', JSON.stringify(legacyNavigationData))
  }

  @inlineError
  async saveNavigationData(navigationRequestValueObject) {
    const {prevPageUrl, nextPageUrl, searchUrl, items, type, totalResults, currentPage} =
      navigationRequestValueObject.toJSON()
    const NAVIGATION_DATA_KEY = this._NAVIGATION_DATA_KEYS[type]
    const adsListVO = this._adsRawListToAdsListVOMapper.map(items)
    const dataToSave = JSON.stringify({
      prevPageUrl,
      nextPageUrl,
      searchUrl,
      items: this._getUniqueAds(adsListVO.getItems())
    })
    switch (type) {
      case this._NAVIGATION_TYPES.ADS:
      default:
        this._localStorage.setItem(NAVIGATION_DATA_KEY, dataToSave)
        this._setLegacyNavigationData({
          prevPageUrl,
          nextPageUrl,
          searchUrl,
          items,
          totalResults,
          currentPage
        })
    }
    return true
  }

  @inlineError
  async getNavigationLinks(navigationLinksRequestValueObject) {
    const {currentPosition, id, type} = navigationLinksRequestValueObject.toJSON()
    const NAVIGATION_DATA_KEY = this._NAVIGATION_DATA_KEYS[type]

    const navigationData = this._localStorage.getItem(NAVIGATION_DATA_KEY)

    const navigationDataValueObject = this._navigationDataValueObject(JSON.parse(navigationData))

    const navigationLinksValueObject = this._navigationDataVOToNavigationLinksVOMapper
      .setParams({currentPosition, id})
      .map(navigationDataValueObject)

    return navigationLinksValueObject
  }

  @inlineError
  async getLastSearchUrl({type}) {
    const NAVIGATION_DATA_KEY = this._NAVIGATION_DATA_KEYS[type]
    const navigationData = this._localStorage.getItem(NAVIGATION_DATA_KEY)

    if (!navigationData) return ''

    const navigationDataValueObject = this._navigationDataValueObject(JSON.parse(navigationData))

    return navigationDataValueObject.getSearchUrl() || ''
  }
}
